var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-time-timezone',{attrs:{"mode":"time","field":_vm.field,"show-timezone":false,"value":_vm.value,"disabled":_vm.disabled,"element-id":_vm.elementId},on:{"update:value":_vm.onInput,"changed":_vm.validate}})}
var staticRenderFns = []

export { render, staticRenderFns }